// ContactInfo.js
import React from "react";
import { about } from "./data"; // Import about data from data.js

const ContactInfo = () => {
  return (
    <section id="contact" className="contact section-bg">
      <div className="container">
        <div className="section-title">
          <h2>Contact Info</h2>
          <p>Get in touch with me!</p>
        </div>

        <div className="row">
          {about.map((info) => (
            <div key={info.id} className="col-lg-6">
              <p>
                <strong>{info.title}:</strong> {info.value}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
